import { render } from "./listDeprivedLibertyByPrisons.vue?vue&type=template&id=591d5fdc"
import script from "./listDeprivedLibertyByPrisons.vue?vue&type=script&lang=js"
export * from "./listDeprivedLibertyByPrisons.vue?vue&type=script&lang=js"

import "./listDeprivedLibertyByPrisons.vue?vue&type=style&index=0&id=591d5fdc&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__